<template>
  <ion-page><cyan-page-wrapper :title="title" :backRoute="backRoute" nav1="DIRECTORIO" :ambito="ambito">
    <territory-picker nextRoute="/dirPickCentro/" :seedTP="seed" />
  </cyan-page-wrapper></ion-page>
</template>

<script lang="ts">
import CyanPageWrapper, {
  defineComponent,
  IonPage,
  store
} from "@/components/CyanPageWrapper.vue";
import TerritoryPicker from "@/components/TerritoryPicker.vue";
import { territorios } from '@/modules/cyanRegions'
import unreact from "@/modules/unreact";

export default defineComponent({
  name: "DirPickMpio",
  components: {
    TerritoryPicker,
    IonPage,
    CyanPageWrapper,
  },
  computed: {
    seed() {
      return unreact((this as any).$route.params.seedPM+'') || 'SV'
    }, 

    ambito() {
			if (this.seed in territorios) {
				return territorios[(this as any).seed].nombre;
			}
			return '';
		},

    title() {
			if (this.ambito) {
				return 'Elegir municipio (' + this.ambito + ')';
			}
			return 'Elegir municipio';
		},
		userLevel() {
      return store.state.userData.nivel || '';
    },
		backRoute() {
			return ((this as any).userLevel != 'SV') ? '/home' : '/dirPickDepto'
		},

  },
  methods: {},
});
</script>
